// extracted by mini-css-extract-plugin
export default {"form-content":"B8QfnXjV1FPTioBT7yFFJ","form-content--horizontal":"_3Bc8odLcbUjsh-YjEPrxeb"};